import * as React from "react";
import type { SVGProps } from "react";
const SvgIconFeedback = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.03 2.4c-.56.06-1.08.36-1.4.8C3.5 3.39.9 7.59.85 7.7c-.1.22-.07.56.06.77.08.13.24.26.4.34.1.05.16.06.32.06q.38 0 .6-.24c.09-.09.5-.72 1.44-2.26.72-1.18 1.34-2.16 1.37-2.2.08-.06.23-.08.32-.03.14.09.14 0 .15 1.81l.01 1.67.06.14q.17.35.53.48c.06.02.61.03 1.9.04l1.82.01.07.07c.15.14.16-.01-.3 3-.45 2.98-.42 2.84-.59 2.93-.08.04-.3.04-3.8.04s-3.73 0-3.84.04c-.24.08-.48.33-.55.54l-.02.3c0 .15 0 .21.06.33.07.16.25.34.42.42l.11.06h3.93c3.68 0 3.93 0 4.08-.04.7-.2 1.28-.78 1.45-1.46.08-.32.88-5.7.88-5.9 0-1.04-.77-1.91-1.8-2.04-.12-.02-.7-.03-1.45-.03H7.25V5.34c-.02-1.15-.02-1.23-.07-1.42-.26-.98-1.16-1.62-2.15-1.52M14.69 8c-.74.17-1.37.76-1.55 1.47-.07.3-.88 5.71-.88 5.92 0 1.04.77 1.9 1.8 2.04l1.45.02h1.24v1.22c.02 1.14.02 1.23.07 1.41q.2.78.86 1.21c.9.6 2.15.34 2.75-.57.22-.33 2.67-4.32 2.71-4.42.1-.22.07-.55-.06-.76-.08-.13-.24-.27-.4-.34-.1-.06-.17-.07-.32-.06q-.37 0-.6.23c-.09.1-.5.73-1.44 2.26-.72 1.18-1.34 2.17-1.37 2.2-.08.07-.23.08-.32.03-.14-.08-.14 0-.15-1.81l-.01-1.67-.07-.13c-.1-.23-.3-.4-.52-.49-.06-.02-.61-.03-1.9-.04l-1.82-.01-.07-.07c-.15-.14-.16.01.3-3 .29-1.92.42-2.77.45-2.81l.1-.1c.07-.04.29-.04 3.85-.06h3.78l.13-.07c.44-.22.62-.72.42-1.14-.07-.16-.24-.34-.4-.42l-.12-.06h-3.9c-2.99 0-3.91 0-4.01.02"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconFeedback;
